.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4.8rem 3.2rem 2.4rem;
  max-width: 47.6rem;
  text-align: center;
  color: white;

  h1 {
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 400;
    margin-bottom: 0.8rem;
  }

  p {
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 300;
  }
}

.icon {
  margin-bottom: 3.2rem;
  svg {
    color: var(--color-error);
    height: 3.6rem;
    width: 3.6rem;
  }
}
